"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPassport = exports.Passport = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const ArcxApi_1 = require("./ArcxApi");
const purple_back_png_1 = __importDefault(require("./assets/purple_back.png"));
const purple_front_png_1 = __importDefault(require("./assets/purple_front.png"));
const Spinner_1 = require("./Spinner");
const useScript_1 = require("./useScript");
const useWindowDimensions_1 = require("./useWindowDimensions");
const offset = 32;
const StyledX = styled_components_1.default.button `
    cursor: grab;
    position: absolute;
    bottom: ${p => (0, styled_components_1.css) `${p.parentHeight - offset}`}px;
    right: ${offset / 2}px;
    width: 1.7rem;
    height: 1.7rem;
    border: 2px solid white;
    border-radius: 50%;
    background-color: black;
    color: white;
    opacity: 0.5;
    z-index: 1000;
    display: none;
`;
const CanvasWrapper = styled_components_1.default.div `
  width: ${p => (0, styled_components_1.css) `${p.width}px`};
  height: ${p => (0, styled_components_1.css) `${p.height}px`};
  position: ${p => (0, styled_components_1.css) `${p.position}`};
  z-index: ${p => (0, styled_components_1.css) `${p.zIndex}`};
  cursor: grab;
  bottom: 18px;
  right: 18px;
  display: flex;
  justify-content: center;
  &:hover ${StyledX} {
    display: block;
  }
`;
const RelativeWrapper = styled_components_1.default.div `
  position: relative;
  width: 100%;
  height: 100%;
`;
const Passport = ({ account, analytics = true, closable = true, position = 'fixed', width = 256, height = 256, chainId = '1', showSpinner = false, arcxUrl = 'https://api.arcx.money', }) => {
    const { width: windowWidth } = (0, useWindowDimensions_1.useWindowDimensions)();
    const canvasRef = (0, react_1.useRef)(null);
    const isLoaded = (0, useScript_1.useScript)(`${arcxUrl}/public/ARCxCardDisplay.js`);
    const [isReady, setIsReady] = (0, react_1.useState)(false);
    const arcxApi = (0, react_1.useRef)(new ArcxApi_1.ArcxApi(arcxUrl));
    const passportMetadata = usePassport(arcxApi.current, account, analytics, chainId);
    // const creditScore = useCreditScore(arcxApi.current, chainId.toString(), account)
    const [closed, setClosed] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if ( /*! creditScore || */!passportMetadata || !isLoaded || (passportMetadata === null || passportMetadata === void 0 ? void 0 : passportMetadata.status) !== 'active')
            return;
        setIsReady(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.ARCxCardDisplay.start({
            canvas: 'arcx-passport-js',
            front: passportMetadata.imageUrlFront,
            back: passportMetadata.imageUrlBack,
            sideColour: '38171d',
            score: ' ',
            scoreFont: '180px sans-serif',
            scoreColour: 'white',
            scoreOffset: 50,
            retina: true,
            supersample: true,
            onReady: () => setIsReady(true),
            width,
            height,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [passportMetadata, isLoaded]);
    const isLoading = !isReady || !passportMetadata;
    const notVisiblePassport = isLoading ||
        passportMetadata.status !== 'active' || (windowWidth < 640 && position === 'fixed');
    /* || !creditScore */
    const hideComponent = (windowWidth < 640 && position === 'fixed') || showSpinner
        ? passportMetadata && passportMetadata.status !== 'active'
        : notVisiblePassport;
    if (closed)
        return null;
    return ((0, jsx_runtime_1.jsx)(CanvasWrapper, Object.assign({ position: position, width: width, height: height, style: {
            display: hideComponent ? 'none' : 'block',
        } }, { children: (0, jsx_runtime_1.jsxs)(RelativeWrapper, { children: [(0, jsx_runtime_1.jsx)("canvas", { id: "arcx-passport-js", ref: canvasRef, style: {
                        width: `${width}px`,
                        height: `${height}px`,
                        display: notVisiblePassport ? 'none' : 'block',
                        // visibility: notVisiblePassport ? 'hidden' : undefined,
                    } }, void 0), closable && (0, jsx_runtime_1.jsx)(StyledX, Object.assign({ parentHeight: height, onClickCapture: () => setClosed(true) }, { children: "X" }), void 0), showSpinner && isLoading && (0, jsx_runtime_1.jsx)(Spinner_1.Spinner, {}, void 0)] }, void 0) }), void 0));
};
exports.Passport = Passport;
const DefaultPassport = ({ width = 256, height = 256, arcxUrl = 'https://staging.api.arcx.money', }) => {
    const [isReady, setIsReady] = (0, react_1.useState)(false);
    const isLoaded = (0, useScript_1.useScript)(`${arcxUrl}/public/ARCxCardDisplay.js`);
    (0, react_1.useEffect)(() => {
        if (!isLoaded)
            return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.ARCxCardDisplay.start({
            canvas: 'arcx-passport-js',
            front: purple_front_png_1.default,
            back: purple_back_png_1.default,
            sideColour: '38171d',
            score: ' ',
            scoreFont: '180px sans-serif',
            scoreColour: 'white',
            scoreOffset: 50,
            retina: true,
            supersample: false,
            onReady: () => setIsReady(true),
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoaded]);
    return ((0, jsx_runtime_1.jsx)(CanvasWrapper, Object.assign({ position: "flex", width: width, height: height }, { children: (0, jsx_runtime_1.jsxs)(RelativeWrapper, { children: [(0, jsx_runtime_1.jsx)("canvas", { id: "arcx-passport-js", style: {
                        width: `${width}px`,
                        height: `${height}px`,
                        display: 'block',
                    } }, void 0), !isReady && (0, jsx_runtime_1.jsx)(Spinner_1.Spinner, {}, void 0)] }, void 0) }), void 0));
};
exports.DefaultPassport = DefaultPassport;
const usePassport = (arcxApi, account, analytics, chainId) => {
    const [passportMetadata, setPassportMetadata] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!account)
            return;
        setPassportMetadata(prev => !prev ? prev : undefined);
        arcxApi.getPassportMetadata(account, chainId.toString()).then(result => setPassportMetadata(result));
    }, [account, analytics, arcxApi, chainId]);
    return passportMetadata;
};
